// extracted by mini-css-extract-plugin
export default {"bars":"Bars_bars__I45XB"};